import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { ToastService } from './services/toast.service';
import { ToastComponent, ToastContainerComponent } from './components/common/toast/toast.component';
import { filter, Subscription } from 'rxjs';
import { NgTemplateOutlet } from '@angular/common';
import { BusinessDetailDrawerService } from './services/business-detail-drawer.service';
import { AddSubscriptionItemComponent } from './components/business-detail/business-billing/add-subscription-item/add-subscription-item.component';
import { InvoiceDetailComponent, InvoiceActionResult } from './components/business-detail/business-billing/invoice-detail/invoice-detail.component';

@Component({
    selector: 'app-root',
    host: { '(document:keydown.escape)': 'onEscape()' },
    imports: [RouterOutlet, SidebarComponent, ToastComponent, ToastContainerComponent, AddSubscriptionItemComponent, InvoiceDetailComponent, NgTemplateOutlet],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy{
  private toastService = inject(ToastService);
  private router = inject(Router);
  drawerService = inject(BusinessDetailDrawerService);

  title = '';
  showNavigation = signal<boolean>(false);
  subShowNav?: Subscription

  get toasts() {
    return this.toastService.toasts();
  }

  ngOnInit(): void {
    this.subShowNav = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(e => {
      const val = e as NavigationEnd
      // login is the one chromeless route: nobody signed out should see the
      // sidebar, and there is nothing in it they could open
      const path = val.url.split('?')[0]
      this.showNavigation.set(path !== '/login')
      // drawer lives in the shell, not in the route, so a navigation would leave it
      // hanging over the new screen (and holding a template of a destroyed component).
      if (this.drawerService.isOpen()) {
        this.drawerService.close()
      }
    })
  }

  ngOnDestroy(): void {
    this.subShowNav?.unsubscribe()
  }

  /** ESC closes the global drawer, as the mat-drawer did. The CDK form drawer handles its own. */
  onEscape(): void {
    if (this.drawerService.isOpen()) this.drawerService.close();
  }

  // Drawer methods
  closeDrawer(): void {
    this.drawerService.close();
  }

  onDrawerClose(): void {
    this.drawerService.close();
  }

  onItemAdded(result: any): void {
    this.drawerService.closeWithResult({
      type: 'add-subscription-item',
      success: result?.success === true,
      data: result
    });
  }

  onInvoiceAction(result: InvoiceActionResult): void {
    this.drawerService.closeWithResult({
      type: 'invoice-detail',
      success: true,
      data: result
    });
  }
}

